export const DASHBOARD_CACHE_CONFIG = {
  // Static data - no TTL (cache forever)
  PROCESS_STATUSES: {
    ttl: null, // Never expires
    refetchOnStale: false
  },

  // Project-scoped data - 5 minute TTL
  PROJECT_USERS: {
    ttl: 5 * 60 * 1000, // 5 minutes
    refetchOnStale: true
  },

  // Project-scoped data - 5 minute TTL
  WORKFLOWS: {
    ttl: 5 * 60 * 1000, // 5 minutes
    refetchOnStale: true
  }
} as const;

// API Endpoints
export const DASHBOARD_CACHE_ENDPOINTS = {
  PROCESS_STATUSES: (projectName: string) =>
    `/api/internal/projects/${projectName}/process/get_process_statuses/`,

  PROJECT_USERS: (projectName: string) =>
    `/api/internal/projects/${projectName}/widgets/projectusers/`,

  WORKFLOWS: (projectName: string) =>
    `/api/internal/projects/${projectName}/bpmn/`
} as const;
